// import '@/modules/vue/assets/index.postcss';
import '@/modules/vue/assets/build.css';
import {Module} from "@/modules";
import {App as AppType, createApp} from 'vue';
import App from './App.vue';
import router from './router';
import {createHead} from '@vueuse/head';
import filters from './plugins/filters';
import enums from './plugins/enums';
import configs from './plugins/configs';
import directives from './plugins/directives';
import dotProp from './plugins/dot-prop';
import {BaseModule} from "@/modules/base";
import {LinkComponentManager} from "@/modules/vue/services/LinkComponentManager";
import {TYPES} from './types';
import {i18n} from "@/modules/vue/i18n";
import messages from "./resources/messages";
import Multiselect from "@vueform/multiselect/src/Multiselect.vue";
import Icon from "./components/Icon.vue";
import Price from "./components/Price.vue";
import {Router} from "vue-router";
import {EventEmitter} from "@/modules/base/events";
import AfterDatabasePreparedEvent from "@/modules/database/events/AfterDatabasePreparedEvent";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isToday from "dayjs/plugin/isToday";
import localizedFormat from "dayjs/plugin/localizedFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";
import {MenuNavigationComponentManager} from "@/modules/vue/services/MenuNavigationComponentManager";
import {ColorEnum, IconEnum} from "@/modules/vue/enums";
import AssetLoader from "@/modules/vue/services/AssetLoader";
import assets from './resources/assets';
import {routes} from './resources/routes';
import {DialogService} from "@/modules/vue/services/DialogService";
import { initializeApp } from "firebase/app";

export {TYPES};

export class VueModule extends Module {
  assets = assets;
  messages = messages;
  routes = routes;

  dependsOn = [
    BaseModule,
  ];

  protected register() {
    super.register();

    this.app.bind<LinkComponentManager>(LinkComponentManager).to(LinkComponentManager);
    this.app.bind<MenuNavigationComponentManager>(MenuNavigationComponentManager).to(MenuNavigationComponentManager);
    this.app.bind<AssetLoader>(AssetLoader).to(AssetLoader);
    this.app.bind<DialogService>(DialogService).to(DialogService);

    // todo move to season module
    dayjs.extend(utc);
    dayjs.extend(isToday);
    dayjs.extend(localizedFormat);
    dayjs.extend(weekOfYear);
    dayjs.extend(weekday);
  }

  public boot() {
    super.boot();

    const appOutside = document.createElement('div');
    appOutside.id = 'app-outside';
    document.body.appendChild(appOutside);

    // this is important so the styles are not overridden by tailwinds preflight reset
    const meta = document.createElement('meta');
    meta.name = 'naive-ui-style';
    document.head.appendChild(meta);

    const head = createHead();
    const vueapp = createApp(App);

    // todo
    dayjs.locale('de');
    i18n.global.locale = 'en';

    vueapp.use(filters);
    vueapp.use(head);
    vueapp.use(i18n);
    vueapp.use(enums);
    vueapp.use(configs);
    vueapp.use(directives);
    vueapp.use(dotProp);
    vueapp.component('Multiselect', Multiselect);
    vueapp.component('Icon', Icon);
    vueapp.component('Price', Price);

    this.app.modules.forEach(module => {
      module.routes.forEach(router.addRoute);
    });

    vueapp.use(router);

    this.app.get(EventEmitter).once(AfterDatabasePreparedEvent, () => vueapp.mount('#app'));

    this.app.bind<AppType>(TYPES.Vue).toConstantValue(vueapp);
    this.app.bind<Router>(TYPES.VueRouter).toConstantValue(router);

    this.app
      .get(MenuNavigationComponentManager)
      .addItem({color: ColorEnum.Lime, icon: IconEnum.PeopleCommunity20Regular, route: {name: 'squads.formation'}})
      .addItem({color: ColorEnum.Lime, icon: IconEnum.IosSearch, route: {name: 'youth.index'}})
      .addItem({color: ColorEnum.Indigo, icon: IconEnum.Handshake20Regular, route: {name: 'negotiations.index'}})
      .addItem({color: ColorEnum.Sky, icon: IconEnum.ClipboardSettings20Regular, route: {name: 'staff.team.index'}})
      .addItem({color: ColorEnum.Amber, icon: IconEnum.EuroFilled, route: {name: 'bank.index'}})
      .addItem({color: ColorEnum.Orange, icon: IconEnum.Dumbbell28Regular, route: {name: 'training.index'}})
      .addItem({color: ColorEnum.Gray, icon: IconEnum.ScoreboardOutlined, route: {name: 'competitions.index'}})
      .addItem({color: ColorEnum.Gray, icon: IconEnum.BuildingMultiple20Regular, route: {name: 'club-grounds.index'}})
      .addItem({color: ColorEnum.Green, icon: IconEnum.StadiumOutlined, route: {name: 'stadiums.index'}});
  }
}
